import React, { Fragment } from 'react';
import {
    DropdownToggle, DropdownMenu,
    Nav, NavItem, NavLink,
    UncontrolledButtonDropdown,
    DropdownItem
} from 'reactstrap';
import cx from "classnames";
import { faPlus, faRotateRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from "react-bootstrap";
import { Skeleton } from '@mui/material';
import {
    Card,
    CardBody,
    Container
} from "reactstrap";

import KPI from './assets/img/kpi.png';
import CHART from './assets/img/chart.png';
import './assets/css/dashboard.css';
import requestApi from "../../services/requestApi.service";
import Common from "../../Common/Common";
import FormHeader from '../../Common/FormHeader';
import PrimaryDashboard from './PrimaryDashboard';
import GraphDashboard from './GraphDashboard';
import { confirmBoxWithImage, getProfileName, getSessionValue, randstr } from '../../Common/Appcommon';
import KPIChartModal from './KPIChartModal';
import ChartConfigModal from './ChartConfig';
import GraphChartModal from './GraphChartModal';
import GraphChartConfig from './GraphChartConfig';
import FolderModal from './FolderModal';
import DashboardHeader from './DashboardHeader';


class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            folderData: [],
            primaryDashboardList: [],
            primaryDashboardData: [],
            secDashboardData: [],
            selectedDashboard: [],
            dashboardData: [],
            refreshvalue: "",
            selectedFolder: {},
            lastRefreshTime: "Just Now",
            isKPIModalOpen: false,
            isConfigModalOpen: false,
            primaryChartType: "",
            primaryChartId: "",
            isGraphChartOpen: false,
            isGraphConfigOpen: false,
            graphChartType: "",
            graphChartId: "",
            isFolderModal: false,
            isNoRecordFound: false,
            isFolderEdit: false,
            userNameList: [],
            selectedUser: {},
            isPrimaryClone: false,
            isGraphClone: false,
            primaryLayout: [],
            graphLayout: [],
            folderLayouts: {},
            profileName: "",
            isLayoutCanceled: false,
            showDashboardLoading: false,
        }
    }

    componentDidMount = async () => {
        let profile = await getProfileName();
        this.setState({
            profileName: profile
        })
        await this.loadPrimaryDashboardData();
        await this.loadCRMUsersList();
    };

    onCreateFolderAction = () => {
        this.setState({
            isFolderModal: true
        })
    }

    updatePrimaryLayoutData = (layout) => {
        this.setState({
            primaryLayout: layout
        })
    }

    updateGraphLayoutData = (layout) => {
        this.setState({
            graphLayout: layout
        })
    }

    onEditFolderAction = () => {
        this.setState({
            isFolderEdit: true,
        })
    }

    disableLayoutCancelClick = () => {
        this.setState({
            isLayoutCanceled: false,
        })
    }

    closeFolderModal = (isRefresh = false, folderId = "", newFolderName = "") => {
        let { selectedDashboard, selectedFolder } = this.state;
        if (newFolderName !== "") {
            selectedDashboard = [folderId, newFolderName];
            let currentUserId = getSessionValue('loginuserid');
            selectedFolder = { "value": folderId, "label": newFolderName, "user": currentUserId }
        }

        this.setState({
            isFolderEdit: false,
            isFolderModal: false,
            selectedFolder: selectedFolder,
            selectedDashboard: selectedDashboard,
        });
        if (folderId === "layoutCancel") {
            this.setState({
                isLayoutCanceled: true,
            })
        }
        if (isRefresh) {
            this.refreshDashboardAction();
        }
    }

    loadPrimaryDashboardData = async () => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FOLDER_LIST",
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let folderData = res.data;
            let primaryDashboardList = [];
            let { selectedDashboard } = this.state;

            primaryDashboardList.push({
                "value": "create_folder",
                "label": "Create Folder",
                color: '#00B8D9'
            });
            folderData.map((item) => {
                primaryDashboardList.push({
                    "value": item[0],
                    "label": item[1],
                    "user": item[2],
                });
                if (selectedDashboard.length === 0) {
                    selectedDashboard = item;
                }
            });
            this.setState({
                folderData,
                primaryDashboardList,
                selectedDashboard,
                selectedFolder: { "value": selectedDashboard[0], "label": selectedDashboard[1], "user": selectedDashboard[2] }
            });
            await this.fetchDashboardDetails(selectedDashboard[0]);
        }
    }

    fetchDashboardDetails = async (folderId) => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "GET_ALL_DASHBOARD_BY_FOLDER",
            "FOLDER_ID": folderId,
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let responseData = res.data;
            let primaryData = responseData['primary'];
            let secData = responseData['graph_dashboard'];
            let primaryLayout = responseData['primaryLayout'];
            let graphLayout = responseData['graphLayout'];
            let lastRefreshTime = "Last updated at: " + responseData['lastrefreshtime'];
            let isNoRecord = primaryData.length === 0 && secData.length === 0 ? true : false;
            this.setState({
                showDashboardLoading: false,
                primaryDashboardData: primaryData,
                secDashboardData: secData,
                lastRefreshTime: lastRefreshTime,
                isNoRecordFound: isNoRecord,
                primaryLayout: primaryLayout,
                graphLayout: graphLayout,
            });
        }
    }

    handleDashboardChange = async (name, selectedOption) => {
        if (name === "Dashboard") {
            let dashboardId = selectedOption.value;
            if (dashboardId === "create_folder") {
                this.onCreateFolderAction();
            } else {
                let dashboardValue = selectedOption.label;
                let dashboardUser = selectedOption.user;
                this.setState({
                    showDashboardLoading: true,
                    refreshvalue: "",
                    selectedFolder: selectedOption,
                    selectedDashboard: [dashboardId, dashboardValue, dashboardUser]
                })
                await this.fetchDashboardDetails(dashboardId);
            }
        } else if (name === "UserFilter") {
            let { selectedDashboard } = this.state;
            let dashboardId = selectedDashboard[0];
            this.setState({
                refreshvalue: "",
                selectedUser: selectedOption,
            })
            await this.fetchDashboardDetails(dashboardId);
        }
    }

    refreshDashboardAction = async (name, e) => {
        this.setState({
            refreshvalue: randstr('refresh_'),
            showDashboardLoading: true,
        });
        await this.loadPrimaryDashboardData();
        await this.updateRecentRefreshTime();
    }

    updateRecentRefreshTime = async () => {
        let { selectedDashboard } = this.state;
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "UPDATE_REFRESH_TIME",
            "FOLDER_ID": selectedDashboard[0],
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let responseData = res.data;
            let lastRefreshTime = "Last updated at: " + responseData[0];
            this.setState({
                lastRefreshTime: lastRefreshTime
            });
        }
    }

    openKPIChartPanel = async () => {
        this.setState({
            isKPIModalOpen: true
        })
    };

    closeKPIPanel = () => {
        this.setState({
            isKPIModalOpen: false
        })
    }

    openPrimaryChartConfigPanel = async () => {
        this.setState({
            isConfigModalOpen: true
        })
    };

    closePrimaryChartConfigPanel = (isRefresh = false) => {
        this.setState({
            isPrimaryClone: false,
            isConfigModalOpen: false,
            primaryChartType: "",
            primaryChartId: "",
        });
        if (isRefresh) {
            this.refreshDashboardAction();
        }
    }

    closeGraphChartConfigPanel = (isRefresh = false) => {
        this.setState({
            //secDashboardData: [],
            isGraphClone: false,
            isGraphConfigOpen: false,
            graphChartType: "",
            graphChartId: "",
        });
        if (isRefresh) {
            this.refreshDashboardAction();
        }
    }

    choosePirmaryChartType = (chartType, chartId = "") => {
        let { primaryChartId } = this.state;
        this.setState({
            isKPIModalOpen: false,
            isConfigModalOpen: true,
            primaryChartType: chartType,
            primaryChartId: chartId == "" ? primaryChartId : chartId,
        })
    }

    chooseGraphChartType = (chartType, chartId = "") => {
        let { graphChartId } = this.state;
        this.setState({
            isGraphChartOpen: false,
            isGraphConfigOpen: true,
            graphChartType: chartType,
            graphChartId: chartId == "" ? graphChartId : chartId,
        })
    }

    changeChartStyle = (chartType) => {
        this.setState({
            isKPIModalOpen: true,
            isConfigModalOpen: false,
            primaryChartType: chartType
        })
    }

    changeGraphChartStyle = (chartType) => {
        this.setState({
            isGraphChartOpen: true,
            isGraphConfigOpen: false,
            graphChartType: chartType
        })
    }

    openGraphChartPanel = async () => {
        this.setState({
            isGraphChartOpen: true
        })
    }

    closeGraphChartPanel = () => {
        this.setState({
            isGraphChartOpen: false
        })
    }

    editChartConfig = async (e, chartId, chartType) => {
        this.choosePirmaryChartType(chartType, chartId);
    }

    cloneChartConfig = async (e, chartId, chartType) => {
        this.setState({
            isPrimaryClone: true,
        })
        this.choosePirmaryChartType(chartType, chartId);
    }

    cloneGraphChartConfig = async (e, chartId, chartType) => {
        this.setState({
            isGraphClone: true,
        })
        this.chooseGraphChartType(chartType, chartId);
    }


    editGraphChartConfig = async (e, chartId, chartType) => {
        this.chooseGraphChartType(chartType, chartId);
    }

    deletePrimaryChart = async (e, chartId) => {
        let title = "Delete Primary Chart?";
        let imageIcon = "";
        let message = "Are you sure you want to delete?";
        let isConfirm = await confirmBoxWithImage(title, message, imageIcon);
        if (isConfirm || isConfirm === "true") {
            let params = {
                "ENTITY": "DashBoard",
                "OPERATION": "DELETE_PRIMARY_CHART",
                "chartId": chartId,
            }
            let res = await requestApi.processServerRequest(params);
            if (res.issuccess) {
                this.refreshDashboardAction();
            }
        }
    }

    deleteGraphChart = async (e, chartId) => {
        let title = "Delete Chart?";
        let imageIcon = "";
        let message = "Are you sure you want to delete?";
        let isConfirm = await confirmBoxWithImage(title, message, imageIcon);
        if (isConfirm || isConfirm === "true") {
            let params = {
                "ENTITY": "DashBoard",
                "OPERATION": "DELETE",
                "dashboardid": chartId,
            }
            let res = await requestApi.processServerRequest(params);
            if (res.issuccess) {
                this.refreshDashboardAction();
            }
        }
    }

    loadCRMUsersList = async () => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "USER_LIST",
        }
        let response = await requestApi.processServerRequest(params, "Mobile");
        if (response.issuccess) {
            let crmUsers = response.data;
            let crmUserFilterOptions = [{ value: "All Users", label: "All Users" }];
            crmUsers.map((crmUser, index) => {
                let userInfo = { value: crmUser['id'], label: crmUser['name'] };
                crmUserFilterOptions.push(userInfo)
            });
            this.setState({
                userNameList: crmUserFilterOptions
            })
        }
    }

    render() {
        let {
            primaryDashboardList,
            primaryDashboardData,
            secDashboardData,
            refreshvalue,
            lastRefreshTime,
            isKPIModalOpen,
            primaryChartType,
            isConfigModalOpen,
            selectedFolder,
            primaryChartId,
            isGraphChartOpen,
            graphChartType,
            graphChartId,
            isGraphConfigOpen,
            isFolderModal,
            isNoRecordFound,
            isFolderEdit,
            selectedDashboard,
            userNameList,
            selectedUser,
            isPrimaryClone,
            isGraphClone,
            primaryLayout,
            graphLayout,
            profileName,
            isLayoutCanceled,
            showDashboardLoading
        } = this.state;
        let curUserId = getSessionValue('loginuserid');
        let isSearchNeeded = getSessionValue("IS_DASHBOARD_SEARCH_NEEDED") !== "" && getSessionValue("IS_DASHBOARD_SEARCH_NEEDED") !== null ? true : false;
        const customStyles = {
            option: (provided, state) => {
                // Check the option value to apply specific styles
                if (state.data.value === 'create_folder') {
                    return {
                        ...provided,
                        backgroundColor: state.data.color,
                        color: 'white',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    };
                }
                // Default option styles
                return {
                    ...provided,
                    cursor: 'pointer',
                };
            }
        };

        let selectOptions = [
            {
                'name': 'Dashboard',
                'options': primaryDashboardList,
                'multiple': false,
                'defaultvalue': Object.keys(selectedFolder).length > 0 ? selectedFolder : primaryDashboardList[1],
                'customStyles': customStyles
            }
        ];
        let buttons = [
            {
                name: 'refresh',
                label: '',
                icon: faRotateRight,
                caption: lastRefreshTime,
            }
        ];

        let moreActions = [];
        if (isSearchNeeded) {
            moreActions = [
                {
                    'name': 'UserFilter',
                    'options': userNameList,
                    'multiple': false,
                    'defaultvalue': userNameList[1],
                }
            ];
        }
        let currentUserId = getSessionValue('loginuserid');
        let moreActionComponent =
            <div className='d-flex'>
                {
                    (profileName.toLowerCase().includes('admin') || (Object.keys(selectedFolder).length > 0 && selectedFolder['user'] === currentUserId)) &&
                    <div className='folder-edit-container'>
                        <a className='cursor-pointer' onClick={(e) => { this.onEditFolderAction(e) }}>Edit</a>
                    </div>
                }
                <div>
                    <UncontrolledButtonDropdown className='dashboard-component'>
                        <DropdownToggle color="link" className="p-0" >
                            <button type="button" className={cx("le-button lePrimaryBtn add-user-btn")}>
                                <span className="ux-icon-button">
                                    <FontAwesomeIcon icon={faPlus} className='mr-1' />
                                    <span className="double-btn-text" data-ellipsis="true">Component</span>
                                </span>
                            </button>
                        </DropdownToggle>
                        <DropdownMenu end className="rm-pointers dropdown-menu-md">
                            <DropdownItem onClick={(e) => { this.openKPIChartPanel(e) }}>
                                <img src={KPI} />
                                <span className='ml-1'>KPI</span>
                            </DropdownItem>
                            <DropdownItem onClick={(e) => { this.openGraphChartPanel(e) }}>
                                <img src={CHART} />
                                <span className='ml-1'>Chart</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>

            </div>

        return (
            <Common pageTitle={"Dashboard"} mainContent={
                <Fragment>
                    {Object.keys(selectedFolder).length > 0 && !isFolderEdit && <FormHeader
                        selectOptions={selectOptions}
                        handleSelectChange={this.handleDashboardChange}
                        handleBtnClick={this.refreshDashboardAction}
                        preFilterButtonOptions={buttons}
                        moreActionComponent={moreActionComponent}
                        moreFilterActions={moreActions}
                    />
                    }
                    {
                        isFolderEdit && <DashboardHeader
                            folderData={selectedFolder}
                            closeModal={this.closeFolderModal}
                            primaryLayout={primaryLayout}
                            graphLayout={graphLayout}
                        />
                    }
                    <div className='dashboard-container'>
                        {!showDashboardLoading &&
                            <div>
                                {isKPIModalOpen &&
                                    <KPIChartModal
                                        isModalOpen={isKPIModalOpen}
                                        closeModal={this.closeKPIPanel}
                                        primaryChartType={primaryChartType}
                                        openChartConfig={this.choosePirmaryChartType}
                                    />
                                }
                                {isGraphChartOpen &&
                                    <GraphChartModal
                                        isModalOpen={isGraphChartOpen}
                                        closeModal={this.closeGraphChartPanel}
                                        graphChartType={graphChartType}
                                        openChartConfig={this.chooseGraphChartType}
                                    />
                                }
                                {isGraphConfigOpen &&
                                    <GraphChartConfig
                                        chartType={graphChartType}
                                        isModalOpen={isGraphConfigOpen}
                                        closeModal={this.closeGraphChartConfigPanel}
                                        changeChartStyle={this.changeGraphChartStyle}
                                        selectedFolder={selectedFolder}
                                        chartId={graphChartId}
                                        isClone={isGraphClone}

                                    />
                                }
                                {isConfigModalOpen &&
                                    <ChartConfigModal
                                        primaryChartType={primaryChartType}
                                        isModalOpen={isConfigModalOpen}
                                        closeModal={this.closePrimaryChartConfigPanel}
                                        changeChartStyle={this.changeChartStyle}
                                        selectedFolder={selectedFolder}
                                        isClone={isPrimaryClone}
                                        primaryChartId={primaryChartId}
                                    />
                                }
                                {!isNoRecordFound && <>
                                    <PrimaryDashboard
                                        selectedDashboard={primaryDashboardData}
                                        isNeedRefresh={refreshvalue}
                                        editChartConfig={this.editChartConfig}
                                        deletePrimaryChart={this.deletePrimaryChart}
                                        user={selectedUser}
                                        cloneChartConfig={this.cloneChartConfig}
                                        isDraggable={isFolderEdit}
                                        updateLayoutData={this.updatePrimaryLayoutData}
                                        layoutInfo={primaryLayout}
                                        isCanceled={isLayoutCanceled}
                                        resetLayoutCancel={this.disableLayoutCancelClick}
                                    />

                                    <GraphDashboard
                                        dashboard={secDashboardData}
                                        isNeedRefresh={refreshvalue}
                                        editChartConfig={this.editGraphChartConfig}
                                        deletePrimaryChart={this.deleteGraphChart}
                                        user={selectedUser}
                                        cloneChartConfig={this.cloneGraphChartConfig}
                                        isDraggable={isFolderEdit}
                                        updateLayoutData={this.updateGraphLayoutData}
                                        layoutInfo={graphLayout}
                                        isCanceled={isLayoutCanceled}
                                    />
                                </>
                                }
                                {
                                    isNoRecordFound && <>
                                        <div className='no-component-found'>
                                            <span>This dashboard doesn't have any components.</span>
                                        </div>
                                    </>
                                }

                                {<FolderModal
                                    isOpen={isFolderModal}
                                    isEdit={isFolderEdit}
                                    folderData={selectedFolder}
                                    closeModal={this.closeFolderModal}
                                />}
                            </div>
                        }
                        {
                            showDashboardLoading && (() => {
                                return (
                                    <div className='ml-1 mr-1 pt-10'>
                                        <Row>
                                            {[...Array(6)].map((_, index) => {
                                                return (
                                                    <Col md="2" className='mb-2'>
                                                        <Card className="main-card border pri-dashboard-card">
                                                            <CardBody>
                                                                <div>
                                                                    <Skeleton animation="wave" />
                                                                </div>
                                                                <div className='text-center'>
                                                                    <Skeleton animation="wave" />
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                        <Row>
                                            {[...Array(2)].map((_, index) => {
                                                return (
                                                    <Col md="6" className='mb-2'>
                                                        <div>
                                                            <Skeleton animation="wave" height={250} />
                                                        </div>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                    </div>
                                )
                            })()
                        }
                    </div>
                </Fragment>
            } />
        )
    }

}

export default Dashboard;
